// The four lenses, as the shell names them. App.jsx pairs each with its component.
export const LENS_META = [
  { id: "today", label: "Today", phase: "attend", short: "Stage" },
  { id: "explore", label: "Explore", phase: "perceive", short: "Map" },
  { id: "field", label: "Field", phase: "survey", short: "Field" },
  { id: "focus", label: "Focus", phase: "act", short: "Focus" },
];

export const lensLabel = id => LENS_META.find(l => l.id === id)?.label || "Today";

// Not a lens of the day: the page that ranks a stretch of past days again (DEC-044).
export const RECALL = { id: "recall", label: "Recall", phase: "look back" };
